import {useProductCounter} from 'hooks/product/useProductCounter';
import {ProductCounterMobile} from 'modules/product-card/components/ProductCounterMobile';
import {FC} from 'react';
import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {selectProductData} from 'modules/product-card/selectors';

export const ProductBuyMobileCartCounter: FC = () => {
    const productData = useAppSelector(selectProductData);
    const productStock = productData?.stockAmount ?? 0;
    const {count, handleChange, handleDecrement, handleIncrement} = useProductCounter(productStock);

    return (
        <div>
            <ProductCounterMobile
                count={count}
                onChange={handleChange}
                onDecrement={handleDecrement}
                onIncrement={handleIncrement}
                disabledIncrement={Boolean(productStock) && count !== undefined && count >= productStock}
            />
        </div>
    );
};
